import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const PreTestReview = () => {
  const { trainingParticipateId } = useParams();

  // alert(trainingParticipateId);
  const [loading, setLoading] = useState(true);
  const [review, setReview] = useState({
    topic_name: "",
    result_status: "",
    pre_test_percentage: 0,
    questions: []
  });

  useEffect(() => {
    fetchReview();
  }, []);

  const fetchReview = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/pretest-review/${trainingParticipateId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );
      console.log(res.data); // DEBUG

      if (res.data.status) {
        setReview(res.data.data);
      } else {
        toast.error("Failed to load review data");
      }
    } catch (error) {
      toast.error("Failed to load review data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="section-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">

              <table className="table table-striped table-bordered">
                <tbody>
                  <tr>
                    <th style={{ color: "blue", fontSize: "15px" }}>
                      Topic Name : {review.topic_name}
                    </th>
                    <th style={{ color: "blue", fontSize: "15px" }}>
                      Pre-Test Result : {review.result_status}
                    </th>
                    <th style={{ color: "blue", fontSize: "15px" }}>
                      Pre-Test Percentage : {review.pre_test_percentage}
                    </th>
                  </tr>
                  <tr>
                    <th style={{ color: "red", fontSize: "15px" }} colSpan="3">
                      Note: Correct Answer Highlighted in Green Color
                    </th>
                  </tr>
                </tbody>
              </table>

              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="mt-3">
                  {review.questions.map((item, index) => (
                    <div className="card mb-3" key={index}>
                      <div className="card-body">
                        <h5 style={{ fontWeight: "700" }}>
                          {item.sl_no}. {item.question} ({item.answer_type})
                        </h5>

                        <ol type="A" className="mt-3">
                          {item.answers.map((ans) => (
                            <li key={ans.id}>
                              <span
                                style={{
                                  color: ans.correct_answer === 1 ? "green" : "black",
                                  fontWeight: ans.correct_answer === 1 ? "600" : "400"
                                }}
                              >
                                {ans.answer}
                              </span>
                            </li>
                          ))}
                        </ol>

                        <div className="mt-3">
                          <span style={{ fontWeight: "900", color: "blue" }}>
                            Your Answer
                          </span>

                          <div className="mt-2">
                            {item.your_answers.length > 0 ? (
                              item.your_answers.map((ans, i) => (
                                <div key={i}>{ans}</div>
                              ))
                            ) : (
                              <div>No answer</div>
                            )}
                          </div>

                          <div className="mt-2">
                            {item.result === "right" ? (
                              <span style={{ color: "green", fontWeight: "600" }}>
                                (Right)
                              </span>
                            ) : item.result === "wrong" ? (
                              <span style={{ color: "red", fontWeight: "600" }}>
                                (Wrong)
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreTestReview;